// This is a very specific Icon so size is the only thing that matters
export const HOUSEHOLD_ARROW_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" fill="none">
  <path d="M7 9L12.0001 0.999946L18.5859 7.58579C19.3669 8.36683 19.3669 9.63317 18.5859 10.4142L12.0001 17.0001L7 9Z" fill="url(#paint0_radial_165_2313)"/>
  <g filter="url(#filter0_f_165_2313)">
    <ellipse cx="7.5" cy="9" rx="3.5" ry="5" fill="#F7F9FA"/>
  </g>
  <defs>
    <filter id="filter0_f_165_2313" x="0" y="0" width="15" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_165_2313"/>
    </filter>
    <radialGradient id="paint0_radial_165_2313" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.99997) rotate(2.48956) scale(11.5109 30.0274)">
      <stop stop-color="#F3F6F7"/>
      <stop offset="1" stop-color="#B6C0C8"/>
    </radialGradient>
  </defs>
</svg>`;
